import { switcher } from 'reducers/utils';
import { ACTIONS } from 'const';

const defaultState = { to: null, text: null };

export default switcher(defaultState, {
    [ACTIONS.SET_SKIP_LINK](state, { payload }) {
        return { ...state, ...payload };
    },
    [ACTIONS.CLEAR_SKIP_LINK](state, { payload }) {
        return defaultState;
    },
});



// WEBPACK FOOTER //
// ./src/reducers/skip_link.js